import strFunc from "@/lib/lyg/string";

function SupplyListArea(props: any) {
  let myProps = {
    supply_info_arr: [],
    set_supply_info_arr: (inData: any) => { },
    ...props
  };
  let supply_info_arr = myProps.supply_info_arr;
  let default_receiv_phone={
    phone_num:"",receiver:"",supply_seq:""
  };

  const on_change_receiv_phone=(inData:any)=>{
    let opt_obj={
      row_num:0,
      name:"",
      value:"",
      ...inData
    };
    let new_supply_info_arr=[...supply_info_arr];
    let supply_info=new_supply_info_arr[opt_obj.row_num];
    let row_pri_val=supply_info["a_ymd"]+","+supply_info["a_seq"];
    let receiv_phone:any={
      ...default_receiv_phone,
      supply_seq:row_pri_val,
    };
    if(supply_info.receiv_phone){
      receiv_phone={
        ...receiv_phone,
        ...supply_info.receiv_phone,
      };
    }
    if (supply_info.stu_info && supply_info.stu_info.link_user_arr && supply_info.stu_info.link_user_arr.length > 0) {
      let par_link_info = supply_info.stu_info.link_user_arr[0];
      if (par_link_info.par_info) {
        if(receiv_phone.phone_num==""){
          receiv_phone={
            ...receiv_phone,
            phone_num:par_link_info.par_info.a_user_phone,
            receiver:par_link_info.par_info.a_user_name,
          };
        }
      }
    }
    receiv_phone[opt_obj.name]=opt_obj.value;
    supply_info.receiv_phone=receiv_phone;
    new_supply_info_arr[opt_obj.row_num]=supply_info;
    myProps.set_supply_info_arr(new_supply_info_arr);
  };

  const get_supply_tr_tags=()=>{
    let tr_tags=supply_info_arr.map((supply_info:any,idx:number)=>{
      let row_pri_val=supply_info["a_ymd"]+","+supply_info["a_seq"];
      let receiv_phone:any={
        ...default_receiv_phone,
        supply_seq:row_pri_val,
      };
      if(supply_info.receiv_phone){
        receiv_phone={
          ...receiv_phone,
          ...supply_info.receiv_phone,
        };
      }
      let par_phone_select_arr:any=[];
      if (supply_info.stu_info && supply_info.stu_info.link_user_arr && supply_info.stu_info.link_user_arr.length > 0) {
        let par_link_info = supply_info.stu_info.link_user_arr[0];
        if (par_link_info.par_info) {
          if(receiv_phone.phone_num==""){
            receiv_phone.phone_num = par_link_info.par_info.a_user_phone;
            receiv_phone.receiver= par_link_info.par_info.a_user_name;
          }
        }
        for(let i=0;i<supply_info.stu_info.link_user_arr.length;i++){
          if(supply_info.stu_info.link_user_arr[i].par_info){
            par_phone_select_arr.push({
              value:supply_info.stu_info.link_user_arr[i].par_info.a_user_phone,
              text:supply_info.stu_info.link_user_arr[i].par_info.a_user_name,
            });
          }
        }
      }
      let supply_phone_num=receiv_phone.phone_num;
      return (
        <tr key={idx}>
          <td className="text-center">{idx+1}</td>
          <td className="text-center">{supply_info.a_stu_name}</td>
          <td className="text-center">{supply_info.a_date}</td>
          <td className="text-center">{supply_info.a_title}</td>
          <td className="text-center">{strFunc.comma(supply_info.a_money_sum)}</td>
          <td className="text-center">
            <input type="text" className="row-input" name="phone_num" value={strFunc.autoHypenPhone(supply_phone_num)} 
              onChange={(e:any)=>{
                on_change_receiv_phone({
                  row_num:idx,
                  name:e.target.name,
                  value:e.target.value
                });
              }}/>
          </td>
          <td className="text-center">
            <select className="row-input" name="phone_num" value={supply_phone_num} 
              onChange={(e:any)=>{
                on_change_receiv_phone({
                  row_num:idx,
                  name:e.target.name,
                  value:e.target.value
                });
              }}>
              <option value="">선택</option>
              {par_phone_select_arr.map((opt:any,idx2:number)=>{
                return (
                  <option key={idx2} value={opt.value}>{opt.text}</option>
                );
              })}
            </select>
          </td>
        </tr>
      );
    });

    return tr_tags;
  };

  return (
    <div>
      <div className="write_table_small">
        <table>
          <colgroup>
            <col width={"5%"}></col>
            <col width={"10%"}></col>
            <col width={"15%"}></col>
            <col width={"25%"}></col>
            <col width={"10%"}></col>
            <col width={"*"}></col>
            <col width={"10%"}></col>
          </colgroup>
          <thead>
            <tr>
              <th>No.</th>
              <th>이름</th>
              <th>청구일</th>
              <th>수납명</th>
              <th>청구금</th>
              <th>청구서받는핸드폰</th>
              <th>선택</th>
            </tr>
          </thead>
          <tbody>
            {get_supply_tr_tags()}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default SupplyListArea;